export function excludeFootnotes (value) {
    return (value || '').replace(/\*/g, '')
}

export function useExcludeFootnotes () {
    return {
        excludeFootnotes,
    }
}